import React from 'react';
import PropTypes from 'prop-types';

import { FormRequired } from '/components/forms/components';

import '/components/forms/components/form-label/form-label.scss';

const FormLabel = ({ label, required }) => {
    if (label) {
        return (
            <div className="form-label">
                {label}
                <FormRequired required={required} />
            </div>
        );
    }

    return null;
};

FormLabel.propTypes = {
    label: PropTypes.string.isRequired,
};

FormLabel.defaultProps = {

};

export { FormLabel };
